import React, { ReactNode } from "react";

import { Sidebar as OldSidebar } from "./Sidebar-old";
import { Sidebar as NewSidebar } from "./Sidebar";
import { useUserData } from "@me8eon/react_authentication";

interface SidebarProps {
    sidebar: ReactNode;
    children: ReactNode;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
}

export const Sidebar = ({ sidebar, children, open, onOpenChange }: SidebarProps) => {
    const { featureFlagEnabled } = useUserData();

    if (featureFlagEnabled) {
        return (
            <NewSidebar sidebar={sidebar} open={open} onOpenChange={onOpenChange}>
                {children}
            </NewSidebar>
        );
    }

    return (
        <OldSidebar sidebar={sidebar}>
            {children}
        </OldSidebar>
    );
};